export default "__VITE_ASSET__BOEhfHKg__"